import Splide from '@splidejs/splide';
import { mobileMatchMedia } from './utility';

export default function slider() {
  const promiseTargets = {
    'js-inview': '-inview',
    'js-imageloaded': '-imageloaded',
  };

  // 初期設定の共通オプション
  const defaultOptions = {
    type: 'loop',
    autoplay: 'pause',
    autoWidth: true,
    gap: '27px',
    pagination: false,
    mediaQuery: 'min',
    autoScroll: {
      speed: 1,
      pauseOnHover: true,
      pauseOnFocus: true,
    },
  };

  // 各条件に応じたオプション
  const pcOptions = {
    focus: 'center',
    padding: { left: '120px', right: '120px' },
    arrows: true,
  };

  const mobileOptions = {
    padding: { left: '20px', right: '20px' },
    arrows: false,
  };

  // クラスが適用されているかを確認
  const isClassApplied = (element, className) => element.classList.contains(className);

  document.querySelectorAll('.js-slider').forEach((element) => {
    const slideNodeList = element.querySelectorAll('.splide__slide');

    // スライド要素が2つ未満の場合は初期化しない
    if (slideNodeList.length < 2) return;

    // Splideの設定オプションを動的に生成
    const splideSettings = {
      ...defaultOptions,
      ...(mobileMatchMedia.matches
        ? mobileOptions
        : slideNodeList.length < 5
          ? { type: 'slide', focus: 1, padding: { left: '0px', right: '0px' } }
          : pcOptions),
      direction: element.classList.contains('js-slider-reverse') ? 'rtl' : 'ltr',
    };

    const splideInstance = new Splide(element, splideSettings);
    splideInstance.mount();

    // Autoplayの制御: クラス変更を監視して再生タイミングを制御
    if (splideSettings.autoplay) {
      const promiseItems = Object.keys(promiseTargets).map((className) => {
        const targetElement = element.closest(`.${className}`);
        if (!targetElement) return Promise.resolve();

        return new Promise((resolve) => {
          // 初期状態でクラスが適用されている場合は即座に解決
          if (isClassApplied(targetElement, promiseTargets[className])) {
            resolve();
            return;
          }

          // MutationObserverでクラスの変更を監視
          const observer = new MutationObserver(() => {
            if (isClassApplied(targetElement, promiseTargets[className])) {
              observer.disconnect();
              resolve();
            }
          });

          observer.observe(targetElement, {
            attributes: true,
            attributeFilter: ['class'], // 必要最低限で監視
          });
        });
      });

      // 全てのPromiseが解決したらAutoplayを開始
      // Promise.all(promiseItems).then(() => {
      //   splideInstance.Components.Autoplay.play();
      // });
    }
  });
}
